import type { FieldBindingRes } from './FieldBindingCanvas.types.ts';

export type HighlightState = 'bound' | 'unbound';

// A field is "bound" once it has a bindingTemplate (a From-data liquid
// expression); everything else still "needs binding". Pure so the visual
// mapping (colour/border) can be unit-tested without mounting react-pdf.
export const highlightStateFor = (
	binding: Pick<FieldBindingRes, 'bindingTemplate'>
): HighlightState => (binding.bindingTemplate != null ? 'bound' : 'unbound');
